
// Non usare i trattini perchè causano errori
export const TEST_DESCRIBE: string = 'test';
